import React, {useState} from 'react'
import { cleanHtml} from './AqUtilities';

export default function AqComment({question,data}) {

    const [showText, setShowText] = useState(false);

    return (
        <div className="aq-comment">
            <div id="title-line">
            <h5>{cleanHtml(question.title)}</h5>    
                <button onClick={()=>setShowText(!showText)} >{showText?"Hide Comments":"Show Comments"}</button>
            </div>
            
            {data && <ul style={{ display: (showText ? "block" : "none") }}>
                {
                    Object.keys(data).map((m, i) => <li key={i}>{m}</li>)
                }
                </ul>
            }
        </div>
    )
}
